export default {
  getters: {
    getTheme: state => state.theme,
    isDarkTheme: state => state.theme === 'dark',
  },
  mutations: {
    setTheme(state, theme) {
      state.theme = theme
      
      // Persist theme preference using localStorage
      try {
        localStorage.setItem('app_theme', theme)
      } catch (e) {
        console.error('Error saving theme preference:', e)
      }
      
      // Apply theme to document
      if (theme === 'dark') {
        document.documentElement.setAttribute('data-theme', 'dark')
      } else {
        document.documentElement.removeAttribute('data-theme')
      }
    },
    initTheme(state) {
      let savedTheme = 'light'
      
      // Get saved theme from localStorage
      try {
        savedTheme = localStorage.getItem('app_theme') || 'light'
      } catch (e) {
        console.error('Error loading theme preference:', e)
      }
      
      state.theme = savedTheme
      
      // Apply theme to document
      if (savedTheme === 'dark') {
        document.documentElement.setAttribute('data-theme', 'dark')
      } else {
        document.documentElement.removeAttribute('data-theme')
      }
    },
    toggleTheme(state) {
      const newTheme = state.theme === 'light' ? 'dark' : 'light'
      state.theme = newTheme
      
      // Persist theme preference using localStorage
      try {
        localStorage.setItem('app_theme', newTheme)
      } catch (e) {
        console.error('Error saving theme preference:', e)
      }
      
      // Apply theme to document
      if (newTheme === 'dark') {
        document.documentElement.setAttribute('data-theme', 'dark')
      } else {
        document.documentElement.removeAttribute('data-theme')
      }
    },
  },
  state: {
    theme: 'light',
  }
}